import { createFileRoute } from '@tanstack/react-router'
import { opportunitySearchSchema } from '@/features/optimization/navigation'
import { OptimizationOpportunities } from '@/features/optimization/opportunities'

export const Route = createFileRoute(
  '/_authenticated/optimization/opportunities/'
)({
  validateSearch: opportunitySearchSchema,
  component: OptimizationOpportunities,
})
